import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import i18n from "../../../functions/i18next";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      show: false,
      successend: false,
      name: "",
      description: "",
      color: "CCC",
      isprivate: 0,
      errors: [],
      user: this.$store.state.user,
      company: this.$store.state.company,
      isUploading: false,
    };
  },
  created() {
    this.$nextTick(() => {
      //this.$refs.name.focus();
    });
  },
  methods: {
    clearErrors() {
      if (this.errors.name !== null) {
        this.errors.name = null;
      }
    },
    addSpace(e) {
      e.preventDefault();
      if (!this.isUploading) {
        this.isUploading = true;

        let formData = new FormData(e.currentTarget);
        this.errors = [];

        formData.append("foldername", this.name);
        formData.append("myspace", "0");
        formData.append("private", this.isprivate);

        this.$axios
          .post(baseUrl + "/folderadd", formData)
          .then((response) => {
            if (response.data.success) {
              this.successend = true;
              EventBus.$emit("spaceadded", "list");
            } else {
              switch (response.data.msg) {
                case "folder_exists":
                  this.errors.push(i18n.t("spaces.space_exists"));
                  break;
              }
            }
          })
          .catch((response) => {
            this.errors.push(
              `${i18n.t("common.something_went_wrong")} ${i18n.t(
                "common.try_again_later"
              )}`
            );
            this.isUploading = false;
          });
      }
    },
  },
};
